import { EmptyPayload } from "../events/types";

export interface TabManagerEvents {
  activeTabChanged: { tabId?: string };
  tabsChanged: { tabs: string[] };
  otherTabTookoverTheTour: EmptyPayload;
  currentTabActivated: EmptyPayload;
  currentTabInactivated: EmptyPayload;
  otherTabActivated: EmptyPayload;
  allTabsInactive: EmptyPayload;
}

export type TabManagerEventContext = {
  tabId: string;
};

export const TabManagerNamespace = "tabManager" as const;
